<template>
  <v-app-bar
    color="white"
    class="elevation-2 rai-content-toolbar"
    style="z-index: 7"
  >
    <v-app-bar-nav-icon @click.stop="switchMenuDrawer"></v-app-bar-nav-icon>
      <v-toolbar-title>
        <div class="subheading rai-project-name-box">{{ `${!hideProjectName && project && project.name ? project.name : ' '}` }}</div>
        <template v-if="title">{{ title }}</template>
        <div><slot></slot></div>
      </v-toolbar-title>
    <v-spacer></v-spacer>

    <v-btn
      v-if="showNaturalLanguageSwitch"
      @click="showLogicalLangage = !showLogicalLangage"
      small
      rounded
      text
      color="grey darken-1"
      class="rai-switch-logical-language"
    >
      <v-icon>{{ showLogicalLangage ? 'mdi-toggle-switch-outline' : 'mdi-toggle-switch-off-outline' }}</v-icon>&nbsp;
      <span>{{ showLogicalLangage ? $t('global.prolog') : $t('global.showNaturalLangage') }}</span>
    </v-btn>

    <v-btn
      v-if="showHelpButton"
      icon
      @click="switchHelpDrawer"
    >
      <v-icon>mdi-help-circle-outline</v-icon>
    </v-btn>

  </v-app-bar>
</template>

<script>
import helpService from '@/services/help.js'

import projectPageMixin from '@/mixins/project-page-mixin.js'
import {HELP_DRAWER,MENU_DRAWER} from '@/store/mutation-types'

export default {
  name: 'PageContentToolbar',

  mixins: [ projectPageMixin ],

  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
    showNaturalLanguageSwitch: {
      type: Boolean,
      required: false,
      default: false,
    },
    hideProjectName: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  computed: {
    showHelpButton() {
      return helpService.isHelpEnabled(this.$route.path)
    },
    showLogicalLangage: {
      get () {
        return this.$store.state.showLogicalLangage;
      },
      set (value) {
        this.$store.commit('UPDATE_SHOW_LOGICAL_LANGAGE', value);
      },
    },
  },

  methods: {
    switchMenuDrawer() {
      this.$store.commit(MENU_DRAWER)
    },
    switchHelpDrawer() {
      this.$store.commit(HELP_DRAWER)
    },
  },
};
</script>

<style>
.rai-content-toolbar .v-toolbar__content {
  background-color: white;
  z-index: 7;
}
.rai-title,.rai-menu-items {
  text-align: left;
  text-transform: none;
  font-size: 1.5em;
}
.rai-content-toolbar {
  box-shadow: 0 2px 2px -2px gray;
  position: sticky;
}
.rai-title, .rai-project-name-box {
  color: #092b86;
}
.rai-project-name-box {
  font-weight: bold;
  font-size: 0.8em;
}
.rai-menu-items {
  font-size: 1.2em;
}
.rai-switch-logical-language {
  width: 120px;
  color: rgba(0, 0, 0, 0.54);
  justify-content: left;
}
.rai-switch-logical-language span {
  width: 100%;

}
</style>